import { SEOConfig } from '@/types/seo';

export const seoConfig: SEOConfig = {
  site: {
    name: 'FortifyTek',
    url: 'https://www.fortifytek.com',
    description: 'FortifyTek provides AI solutions and enterprise technology services. We specialize in NetSuite ERP, Shopify Plus, Celigo iPaaS, and PowerBI analytics.',
    logo: 'https://www.fortifytek.com/logo.png',
    social: {
      twitter: '@fortifytek',
      linkedin: 'https://linkedin.com/company/fortifytek',
      github: 'https://github.com/fortifytek',
    },
  },
  organization: {
    name: 'FortifyTek',
    alternateName: 'FortifyTek Solutions',
    url: 'https://www.fortifytek.com',
    logo: 'https://www.fortifytek.com/logo.png',
    description: 'FortifyTek provides AI solutions and enterprise technology services. We specialize in NetSuite ERP, Shopify Plus, Celigo iPaaS, and PowerBI analytics.',
    email: 'ftsupport@fortifytek.com',
    telephone: '+14242424140',
    address: {
      addressLocality: 'Riverside',
      addressRegion: 'CA',
      addressCountry: 'US',
    },
    sameAs: [
      'https://twitter.com/fortifytek',
      'https://linkedin.com/company/fortifytek',
      'https://github.com/fortifytek',
      'https://www.facebook.com/fortifytek',
      'https://www.youtube.com/@fortifytek',
    ],
    foundingDate: '2020',
    numberOfEmployees: {
      minValue: 50,
      maxValue: 100,
    },
  },
  defaultMeta: {
    title: 'FortifyTek | AI Solutions & Enterprise Technology | NetSuite, Shopify Plus, PowerBI',
    description: 'Transform your enterprise with FortifyTek AI solutions, NetSuite ERP, Shopify Plus & PowerBI. Experienced team delivering enterprise technology solutions. Get a free consultation today.',
    keywords: [
      // Primary service keywords
      'AI solutions',
      'AI development company',
      'enterprise AI',
      'machine learning services',
      'NetSuite developer',
      'NetSuite implementation partner',
      'NetSuite ERP consultant',
      'Shopify Plus partner',
      'Shopify Plus agency',
      'Shopify Plus development',
      'Celigo integration',
      'Celigo iPaaS',
      'PowerBI analytics',
      'PowerBI consultant',
      // Technology keywords
      'enterprise software',
      'ERP implementation',
      'e-commerce development',
      'business intelligence',
      'AI agents',
      'RAG systems',
      'workflow automation',
      'digital transformation',
      'cloud migration',
      'API integration',
      'custom software development',
      // Benefit-focused keywords
      'increase business ROI',
      'enterprise automation',
      'scalable tech solutions',
      'reduce operational costs',
    ],
    ogImage: 'https://www.fortifytek.com/og-image.jpg',
  },
  keywords: {
    primary: [
      'AI solutions company',
      'NetSuite implementation partner',
      'Shopify Plus certified partner',
      'Celigo integration experts',
      'PowerBI analytics consulting',
      'enterprise technology partner',
    ],
    secondary: [
      'enterprise software development',
      'machine learning implementation',
      'ERP customization services',
      'e-commerce optimization',
      'business intelligence dashboards',
      'workflow automation solutions',
      'digital transformation consulting',
      'cloud infrastructure services',
    ],
    longTail: [
      'NetSuite ERP implementation services USA',
      'Shopify Plus enterprise e-commerce agency',
      'AI-powered business automation solutions 2025',
      'custom PowerBI dashboard development services',
      'Celigo integration platform consulting services',
      'enterprise AI chatbot development company',
      'NetSuite SuiteScript custom development',
      'Shopify Plus headless commerce development',
      'real-time analytics dashboard implementation',
      'AI workflow automation for enterprise',
    ],
    local: [
      'AI solutions company California',
      'NetSuite developer Riverside CA',
      'Shopify Plus partner Los Angeles',
      'enterprise software development California',
      'PowerBI consultant Southern California',
      'technology consulting firm California',
    ],
  },
};